export const ROUTE_ROOT = "/";
export const ROUTE_SIGNIN = "/signin";
export const ROUTE_DASHBOARD = "/admin/dashboard";
export const ROUTE_HOSTELS = "/admin/hostels";
export const ROUTE_REGISTRATIONS = "/admin/registrations";

export const ROUTE_PUBLIC_REGISTER = "/register";
export const ROUTE_VOLUNTEER_REGISTER = "/volunteer/register";
